// src/lib/constants.ts

export const TABLE_NAMES = {
  PROFILES: "profiles" as const,
  EDIFICIO: "edificio" as const,
  UNIDAD: "unidad" as const,
  INQUILINO: "inquilino" as const,
  DEUDA_MENSUAL: "deudamensual" as const,
  REGISTRO_PAGO: "registropago" as const,
  CONCEPTO_DE_DEUDA: "conceptodedeuda" as const,
};
